import { Component, h, Host, State, Prop } from '@stencil/core';
import 'aiba-component-library';
import { analyticsService, binService, pdfService, profileService, recommendationService, feedbackService } from 'aiba-ui-services';
import { getScreenData } from '../../data';
import * as utils from '../../../../../common/skin-quiz/utils/utils';
import * as stateutilsClosure from '../../../../../common/skin-quiz/utils/state.utils';
import * as config from '../../root/config';
import { getState } from '../../utils/store';
import translationValues from '../../i18n/locales/target.json';

import * as breadCrumbStepHandlers from '../../../../../common/skin-quiz/handlers/breadcrumb.handler';
import { fetchTranslations } from '../../../../../common/skin-quiz/utils/translations.utils';
import * as welcomeScreenHandlers from '../../../../../common/skin-quiz/handlers/welcome.handlers';
import * as quizScreenHandlers from '../../../../../common/skin-quiz/handlers/quiz.handlers';
import * as analyzeScreenHandlers from '../../../../../common/skin-quiz/handlers/analyze.handlers';
import * as resultScreenHandlers from '../../../../../common/skin-quiz/handlers/result.handlers';
import * as selfieIntroScreenHandlers from '../../../../../common/skin-quiz/handlers/selfieintro.handlers';
import { scrollToTop } from '../../../../../common/skin-quiz/utils/utils';
@Component({
  tag: 'aiba-app',
  styleUrl: '../../global/global.scss',
  shadow: true,
})
export class AibaApp {
  @State() breadCrumbData: [];
  @State() state: any = {};
  @Prop() styles: any;

  
  async connectedCallback() {
    try {
      console.log('@AIBA[app.connectedCallback.fetchTranslations]: DONE', 1);
    } catch (error) {
      console.error('@AIBA[app.connectedCallback.fetchTranslations.error]: ', error);
    }
  }
  async componentWillLoad() {
    this.state = await getState();
    const stateutils = stateutilsClosure.stateUtils(this.state);
    window['AIBA'] = { utils: { ...utils, ...stateutils, binService, pdfService, profileService, recommendationService, analyticsService, feedbackService } };
    const {
      default: {
        brand: { brand, locale, version, journey_type },
      },
    } = config;
    const I18N_WEB_STORAGE_KEY = `aiba.${brand}.${locale.toLowerCase()}.${journey_type}.${version}`;
    await stateutils.setConfig(config);
    await fetchTranslations(translationValues, I18N_WEB_STORAGE_KEY);
  }
  isValidUrl(str) {
    const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
    return urlRegex.test(str);
  }
  async fetchAndApplyCSS() {
    if (this.isValidUrl(this.styles)) {
      try {
        const response = await fetch(this.styles);
        if (response.status !== 200) {
          throw new Error('Network response was not ok');
        }
        this.styles = await response.text();
      } catch (error) {
        console.error('@AIBA[app.fetchAndApplyCSS.error]: ', error);
      }
    }
  }
  
  async componentWillRender() {
    scrollToTop();
    this.fetchAndApplyCSS();
    this.breadCrumbData = await breadCrumbStepHandlers.handleBreadCrumbOnLoad();
  }
  onclick = event => {
    analyticsService.registerEvent('event2', event);
  };
  render() {
    return (
      <Host>
        {this.styles && !this.isValidUrl(this.styles) && <style>{this.styles}</style>}
        <section class={`screen-wrapper ${this.state.currentJourney}`}>
          <div>
            {this.state.currentJourney === 'welcome_screen' && (
              <aiba-welcome-screen getData={() => getScreenData('aiba-welcome-screen')} handlers={welcomeScreenHandlers}></aiba-welcome-screen>
            )}
            {this.state.currentJourney === 'selfie_intro_screen' && (
              <aiba-selfie-intro-screen getData={() => getScreenData('aiba-selfie-intro-screen')} handlers={selfieIntroScreenHandlers} />
            )}
            {this.state.currentJourney === 'quiz_screen' && <aiba-quiz-screen getData={() => getScreenData('aiba-quiz-screen')} handlers={quizScreenHandlers}></aiba-quiz-screen>}
            {this.state.currentJourney === 'analyze_screen' && (
              <aiba-analyze-screen getData={() => getScreenData('aiba-analyze-screen')} handlers={analyzeScreenHandlers}></aiba-analyze-screen>
            )}
            {this.state.currentJourney === 'result_screen' && (
              <aiba-result-screen getData={() => getScreenData('aiba-result-screen')} handlers={resultScreenHandlers}></aiba-result-screen>
            )}
          </div>
        </section>
      </Host>
    );
  }
}
